import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

import TextField from './TextField';

import type { FC } from 'react';
import type { TextFieldProps } from './TextField';

interface SSNMaskProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const SSNMask = forwardRef<HTMLInputElement, SSNMaskProps>(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="000-00-0000"
      inputRef={ref}
      onAccept={(value: string) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

const SSNField: FC<Omit<TextFieldProps, 'placeholder' | 'pattern'>> = ({ InputProps, ...props }) => {
  return (
    <TextField
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      InputProps={{ inputComponent: SSNMask as any, ...InputProps }}
      placeholder="###-##-####"
      pattern="^[0-9]{3}-[0-9]{2}-[0-9]{4}$"
      {...props}
    />
  );
};

export default SSNField;
